<template>
  <div class="w-full">
    <div class="flex flex-col mt-4" v-if="emailData == null">
      <div class="text-center">
        <i class="fas fa-circle-notch fa-spin text-5xl"></i>
      </div>
    </div>
    <div>
      <div class="flex flex-col mt-4" v-if="emailData !== null">
        <div class="bg-white rounded-lg shadow-md mb-8">
          <div
            class="p-4 bg-gray-600 shadow-md rounded-lg w-full cursor-pointer select-none"
          >
            <div class="flex flex-row items-center">
              <div class="flex-1 overflow-none">
                <h2 class="text-lg font-semibold text-white whitespace-no-wrap">
                  {{ emailData.title }}
                </h2>
              </div>
              <div
                class="bg-gray-300 px-2 py-1 rounded"
                :title="localTime(emailData.created_at)"
                v-tippy
              >
                {{ emailData.created_at | timeAgo }}
              </div>
            </div>
          </div>
          <div class="py-4">
            <div class="w-full flex flex-row justify-between px-4 my-4">
              <div class="flex flex-col items-center content-center">
                <h3 class="font-bold text-xl">
                  {{ emailData.analytics.sentEmails }}
                </h3>
                <span class="text-uppercase text-gray-500 font-bold"
                  >Emails Sent</span
                >
              </div>
              <div class="flex flex-col items-center content-center">
                <h3 class="font-bold text-xl">
                  {{ emailData.analytics.openedEmails }}
                </h3>
                <span class="text-uppercase text-gray-500 font-bold"
                  >Email Views</span
                >
              </div>
              <div class="flex flex-col items-center content-center">
                <h3 class="font-bold text-xl">
                  {{ emailData.analytics.linksFollowed }}
                </h3>
                <span class="text-uppercase text-gray-500 font-bold"
                  >Video Views</span
                >
              </div>
              <div class="flex flex-col items-center content-center">
                <h3 class="font-bold text-xl">
                  {{ emailData.analytics.purchases }}
                </h3>
                <span class="text-uppercase text-gray-500 font-bold"
                  >Purchases</span
                >
              </div>
            </div>
            <div class="mt-4 px-4">
              <span class="font-bold text-uppercase text-gray-800"
                >Most Viewed Video</span
              >
              <span
                class="ml-2"
                v-if="emailData.analytics.mostViewedVideo == null"
                >N/A</span
              >
              <div class="" v-if="emailData.analytics.mostViewedVideo !== null">
                <div class="flex mt-1">
                  <img
                    class="h-24 w-auto rounded-lg"
                    :src="
                      emailData.analytics.mostViewedVideo.video.thumbnailUrl
                    "
                  />
                  <div class="px-4">
                    <p class="text-lg font-semibold">
                      {{ emailData.analytics.mostViewedVideo.video.title }}
                    </p>
                    <p>
                      {{ emailData.analytics.mostViewedVideo.video.user.name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4 px-4">
              <span class="font-bold text-uppercase text-gray-800"
                >Videos Included</span
              >
              <div class="" v-if="emailData.analytics.mostViewedVideo !== null">
                <div class="flex flex-wrap">
                  <div
                    class="w-full md:w-1/2 flex flex-row items-center mb-4"
                    v-for="video in emailData.rawVideos"
                  >
                    <img
                      class="h-24 w-auto rounded-lg"
                      :src="video.thumbnailUrl"
                    />
                    <div class="px-4">
                      <p class="text-lg font-semibold">{{ video.title }}</p>
                      <p>{{ video.user.name }}</p>
                      <p>ID: {{ video.id }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="mt-4 px-4">
                            <span class="font-bold text-uppercase text-gray-800">Custom Pricing Information</span>
                            <div class="" v-if="emailData.analytics.mostViewedVideo !== null">
                                <div class="flex flex-wrap mt-1">
                                    <table class="w-full">
                                        <tr>
                                            <td>Video ID</td>
                                            <td>Default Price</td>
                                            <td v-for="val in Object.keys(emailData.pricing)[0]">
                                                {{ getNetworkById(val) }}
                                            </td>
                                        </tr>
                                        <tr v-for="(pricing, key) in emailData.pricing">
                                            <td>{{ key }}</td>
                                            <td>
                                                {{ getDefaultPriceForVideo(key) }}
                                            </td>
                                            <td v-for="price in pricing">{{price}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div> -->
          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow-md" v-if="emailData !== null">
        <div
          class="bg-gray-600 px-4 py-3 rounded-t-lg text-white text-uppercase font-semibold text-lg"
        >
          <h2>Events</h2>
        </div>

        <CustomTable>
          <template v-slot:header>
            <th
              class="py-4 px-2 border-b border-grey-light font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Network
            </th>
            <th
              class="py-4 px-4 border-b border-grey-light font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              User
            </th>
            <th
              class="py-4 px-4 border-b border-grey-light font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Action
            </th>
            <th
              class="py-4 px-4 border-b border-grey-light font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
            >
              Event At
            </th>
          </template>
          <template v-slot:body>
            <tr v-for="event in emailData.events">
              <td class="py-4 px-2 border-b border-grey-light">
                {{ event.reservation.user.network.name }}
              </td>
              <td class="py-4 px-4 border-b border-grey-light">
                {{ event.reservation.user.name }}
              </td>
              <td class="py-4 px-4 border-b border-grey-light">
                <span>{{ event.event }}</span>
                <div class="mt-2" v-if="event.event == 'Viewed'">
                  <span>{{ event.video.title }}</span>
                </div>
              </td>
              <td class="py-4 px-4 border-b border-grey-light">
                {{ event.created_at | displayLocalDateTime }}
              </td>
            </tr>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/events";
import * as Config from "@/config";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import CustomTable from "@/components/general/CustomTable";

export default {
  name: "MailList",
  data() {
    return {
      emailData: null,
      networks: {}
    };
  },
  components: {
    CustomTable
  },
  mounted() {
    this.getNationalNetworks();
    this.loadLatestEmails();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    loadLatestEmails() {
      this.loading = true;

      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/mail/latest/" + this.$route.params.id,
          this.getAuthorizationHeader()
        )
        .then(response => {
          this.$set(this, "emailData", response.data);
          this.$set(this, "loading", false);
        });
    },
    localTime(dt) {
      return moment
        .utc(dt)
        .local()
        .format("MMMM Do YYYY, h:mm a");
    },
    getNationalNetworks() {
      var _this = this;
      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/networks?type=national",
          this.getAuthorizationHeader()
        )
        .then(response => {
          _this.networks = response.data;
        });
    },
    getNetworkById(key) {
      return this.networks
        .filter(function(data) {
          return data.id == key;
        })
        .map(function(obj) {
          return obj.name;
        })[0];
    },
    getDefaultPriceForVideo(id) {
      return this.emailData.rawVideos
        .filter(function(data) {
          return data.id == id;
        })
        .map(function(obj) {
          return obj.price;
        })[0];
    }
  },
  filters: {
    timecode: function(value) {
      if (value !== null) {
        var seconds = Math.floor(value % 60).toString();
        var minutes = Math.floor(value / 60).toString();
        if (seconds.length === 1) {
          seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
      }
    },
    timeAgo: function(date) {
      return moment.utc(date).fromNow();
    },
    displayLocalDateTime: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do YYYY, h:mm a");
    }
  }
};
</script>
